import parseLinkHeader from "parse-link-header";

import { authRequestRaw } from "@api/auth/auth";
import { checkStatus } from "@api/fetch";
import { DEPLOYMENT_URL } from "@constants";
import {
  FetchFindingsResponse,
  FindingCounts,
  FindingFilterItems,
  OrgData,
} from "@types";
import { _getFindingsParamsFromSearch } from "@utils/getFindingsParamsFromSearch";

import { Finding } from "@pages/findings/types";

const _fetchFindings = async (
  org: OrgData,
  url: string | undefined,
  searchParams?: URLSearchParams
): Promise<FetchFindingsResponse> => {
  // This function requests findings in batches, to prevent OOM for
  // deployments with exceptionally high numbers of findings

  let queryParams = new URLSearchParams();
  if (searchParams) {
    // Clean up search params
    queryParams = _getFindingsParamsFromSearch(searchParams);
  }

  if (url === undefined) {
    const qs = queryParams.toString();
    url = `${DEPLOYMENT_URL}/${org.id}/issues/v2`;
    if (qs !== "") {
      url += `?${qs}`;
    }
  }
  // Uses response headers to request next chunk of data
  const header = { "X-FeatureFlags": "true" } as Record<string, string>;
  const response: Response = await authRequestRaw(
    "get",
    url,
    undefined,
    header
  );
  checkStatus(response);
  const linkHeader = response.headers.get("Link");
  const parsedLinks = linkHeader ? parseLinkHeader(linkHeader) : null;
  const response_body = await response.json();
  const fetchedFindings = response_body.issues as Finding[];
  const fetchedCounts = response_body.counts as FindingCounts;
  const fetchedFilterItems = response_body.filters as FindingFilterItems;
  const cursor = response_body.cursor;
  return {
    fetchedFindings,
    fetchedCounts,
    fetchedNextUrl: parsedLinks?.["next"]?.url,
    fetchedFilterItems,
    cursor,
  };
};

export const fetchDeploymentFindingsPaginated = (
  org: OrgData,
  searchParams: URLSearchParams,
  cursor?: string
): Promise<FetchFindingsResponse> => {
  if (cursor) {
    searchParams.set("cursor", cursor);
  }
  return _fetchFindings(org, undefined, searchParams);
};
